import routesJson from "routes.json"

// Weeee
export const { staticPaths, rewrites } = routesJson[process.env.NEXT_PUBLIC_ID]
